import SliderComponent from 'react-slick'
import styled          from 'styled-components'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const settingsDefault = {
  autoplay: false,
  autoplaySpeed: 5000,
  arrows: false,
  centerMode: false,
  dots: true,
  infinite: false,
  speed: 500
}

const Slider = ({settings, ...props}) =>
  <StyledSliderComponent className={props.className} {...settingsDefault} {...settings}>
    {props.children}
  </StyledSliderComponent>

export default Slider

const StyledSliderComponent = styled(SliderComponent)`
  .slick-dots {
    bottom: -30px;
    li {
      button {
        width: 12px;
        height: 12px;
        border: 1px solid white;
        border-radius: 50%;
        transition: 100ms;

        &:before {
          display: none;
        }
      }

      &.slick-active {
        button {
          border-color: #00EEB8;
          background: #00EEB8;
        }
      }
    }
  }
`
